module.exports = __webpack_public_path__ + "img/irish-immigrants.366deadd.png";